import endpoints from 'api/endpoints';
import { api } from 'api/rest';

export class PushNotificationService {
  static async createNotification(data) {
    const response = await api.post(endpoints.pushNotifications, data);
    return response;
  }
}
